module.exports = __webpack_public_path__ + "static/media/map_route.0f29db3c.jpg";